<template>
    <div class="custom-file">
        <template v-if="multiple === false">
            <input
                ref="input_file_ref"
                type="file"
                class="custom-file-input"
                :accept="accept"
                @input="fileValue = []"
                @change="onChange($event);"
                :disabled="disabled"
            />
            <label class="custom-file-label" :class="fileValue.length ? 'bg-light text-dark fw-bold' : '' " v-html="fileValue.length && fileValue[0] ? fileValue[0].name : placeholder"></label>
            <div v-if="fileSizeError" v-html="fslError"></div>
        </template>

        <template v-else-if="multiple === true">
            <input
                ref="input_file_ref"
                type="file"
                class="custom-file-input"
                multiple
                :accept="accept"
                @input="fileValue = []"
                @change="onChange($event);"
                :disabled="disabled"
            />
                <!-- @change="onChange($event); $emit('update:modelValue', $event.target.files); $emit('select', $event.target)" -->
            <slot name="label">
                <label class="custom-file-label" :class="(fileValue.length ? 'bg-light text-dark fw-bold' : '') + ' ' + (disabled ? 'disabled' : '') " v-html="fileValue.length ? `Fayl sayı: ${fileValue.length}` : placeholder"></label>
            </slot>
            <slot name="content">
                <div v-if="!fileSizeError && fileValue.length" class="d-flex flex-column gap-8">
                    <div v-if="totalSize" class="bg-light fw-semibold text-center py-1">{{ G.formatSize(totalSize) }}</div>
                    <div v-for="(file, findex) of fileValue" :key="findex" class="p-2 border border-bottom d-flex flex-row border align-items-center">
                        <div v-if="file.type !== undefined">
                            <!-- <img v-if="file.type && file.type.match('^image')" role="presentation" :alt="file.type" :title="file.name" :src="file.objectPath" width="50" height="auto" /> -->
                            <Image
                                v-if="file.type && file.type.match('^image')"
                                :src="file.objectPath"
                                :alt="file.type"
                                :title="file.name"
                                width="50"
                                height="auto"
                                :preview="true"
                            />
                            <div v-else :title="file.name"  class="text-secondary" style="width: 50px; text-align: center; font-size: 2rem !important;" v-html="G.getFileMimeType(file)"></div>
                        </div>

                        <div v-else-if="file.filename !== undefined">
                            <!-- <img v-if="['jpg', 'jpeg', 'png'].indexOf(file.filename.split('.').at(-1)) != -1" role="presentation" :alt="file.name" :title="file.name" :src="file.filename" width="50" height="auto" /> -->
                            <Image
                                v-if="['jpg', 'jpeg', 'png'].indexOf(file.filename.split('.').at(-1)) != -1"
                                :src="file.filename"
                                :alt="file.name"
                                :title="file.name"
                                width="50"
                                height="auto"
                                :preview="true"
                            />
                            <div v-else :title="file.name"  class="text-secondary" style="width: 50px; text-align: center; font-size: 2rem !important;" v-html="G.getFileMimeType(file)"></div>
                        </div>

                        <div class="flex-column ms-3 me-auto col-9">
                            <a v-if="file.filename !== undefined" :href="file.filename" target="blank" class="text-primary fw-bold">{{ file.name }}</a>
                            <span v-else class="fw-semibold text-truncate text-wrap overflow-hidden">{{ file.name }}</span>
                            <div class="me-auto">{{ file.size ? G.formatSize(file.size) : '' }}</div>
                        </div>

                        <i class="fas fa-circle small me-3" :class="file.filename ? 'text-primary' : 'text-warning' "></i>
                        <button v-if="G.userHavePermission('add') || G.userHavePermission('update')" class="btn ms-1" @click="onRemoveTemplatingFile(file, findex)">
                            <div class="fas fa-times text-danger"></div>
                        </button>
                    </div>
                </div>
                <div v-else-if="fileSizeError" v-html="fslError"></div>

            </slot>

            <slot name="uploadedcontent"></slot>
        </template>
    </div>
</template>

<script>
import { ref, watchEffect } from 'vue';

import Image from "primevue/image";

import { G } from '@/_common';

export default {
    name: "InputFileC",
    components: {
        Image,
    },
    props: {
        multiple: {
            type: Boolean,
            default: false,
        },
        input_file_ref: {
            type: Object,
            default: () => {
                return null;
            },
        },
        files: {
            type: Array,
            default: () => [],
        },
        accept: {
            type: String,
            default: 'application/pdf',
        },
        maxSize: {
            type: Number,
            default: 52428800,
        },
        sizeErrorLabel: {
            type: String,
            default: 'Files size error ! Max:',
        },
        placeholder: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update:modelValue', 'select'],
    setup(props, context) {
        const fileValue = ref([]);
        const fileSizeError = ref(false);
        const fslError = ref(props.placeholder);

        const totalSize = ref(0);

        const onChange = (event) => {
            totalSize.value = 0;

            fileValue.value = Array.from(event.target.files).map(f => {
                totalSize.value += f.size;
                return Object.assign(f, {"objectPath": URL.createObjectURL(f)});
            });
            context.emit('update:modelValue', event.target.files);
            context.emit('select', event.target)
        };

        var a = 0;
        watchEffect(() => {
            if( props.multiple == true ){
                fileValue.value = props.files.length ? props.files : [];
            }
            let b = fileValue.value;
            for(let i=0; i < b.length; i++){
                let e = b[i];
                a += e.size;
            }
            fileSizeError.value = a > props.maxSize ? true : false;
            a = 0;
            if( fileSizeError.value ){
                fileValue.value = [];
                fslError.value = `<span class="text-danger small">${props.sizeErrorLabel.replace('{0}', (props.maxSize/1048576).toFixed(2) + ' Mb')}</span>`;
            }
        });

        const clear = () => {
            fileValue.value = [];
        };

        const onRemoveTemplatingFile = (file, index) => {
            let ar = Array.from(fileValue.value);
            ar.forEach((e, i) => {
                if( e.name == file.name ){
                    totalSize.value -= file.size;
                    ar.splice(i, 1);
                    props.files.splice(i, 1);
                }
            });
            fileValue.value = ar;
        };

        // const getimgsize = (file) => {
        //     const xhr = new XMLHttpRequest();
        //     const method = 'HEAD';
        //     const url = file.filename;
        //     xhr.open(method, url);
        //     xhr.onreadystatechange = () => {
        //         if( xhr.readyState == 4) {
        //             if( xhr.status == 200 ) {
        //                 var fileSize = xhr.getResponseHeader('Content-Length');
        //                 console.log(fileSize);
        //             } else {
        //                 console.info('XHR readyState: ' + xhr.readyState);
        //             }
        //         }
        //     };
        //     xhr.send(null);
        // };

        return {
            G,
            fileValue,
            fileSizeError,
            fslError,
            clear,
            onRemoveTemplatingFile,
            onChange,
            totalSize,
        };
    },
}
</script>


<style lang="scss">
    .custom-file {
        position: relative;
        display: inline-block;
        width: 100%;
        // height: calc(2rem + 2px);
        margin-bottom: 0;

        .custom-file-input {
            position: relative;
            z-index: 2;
            width: 100%;
            height: calc(2rem + 2px);
            margin: 0;
            overflow: hidden;
            opacity: 0;
            // padding: .4rem;
            cursor: pointer;
        }
        .custom-file-label {
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            z-index: 1;
            cursor: pointer;

            // height: calc(2rem + 2px);
            // padding: .5rem;
            // overflow: hidden;
            // font-weight: 400;
            // line-height: 1.8;

            height: calc(2rem + 2px);
            padding: 1.25rem;
            overflow: hidden;
            font-weight: 400;
            line-height: 0;

            color: #495057;
            background-color: #ffffff13;
            // background-color: transparent;
            border: 1px solid #ced4da;
            border-top-color: rgb(206, 212, 218);
            border-right-color: rgb(206, 212, 218);
            border-bottom-color: rgb(206, 212, 218);
            border-left-color: rgb(206, 212, 218);
            border-radius: .25rem;
        }
        .custom-file-label::after {
            content: '...';
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 3;
            display: block;
            // height: calc(1.5em + .75rem);
            padding: .4rem .75rem;
            line-height: 1.5;
            color: #495057;
            background-color: var(--bs-primary);
            color: var(--bs-white);
            border-left: inherit;
            border-left-color: inherit;
            border-radius: 0 .25rem .25rem 0;
        }
    }
</style>
